import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          unstyled: false,
          classNames: {
            toast:
              "!rounded-none !border !border-black !bg-white !text-black !font-mono !text-sm",
            success: "!border-black",
            error: "!border-[#e63946]",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
